var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"WaveBg-wrap"},[_c('ItemWave1',{staticClass:"ItemWave1-component",attrs:{"r":229,"g":220,"b":232,"opacity":0.5,"multipleWave":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }